<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提成结算</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <!-- <el-form-item label="时间段" label-width="80px" style="margin-left:8px;">
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            value-format="yyyy-MM-dd HH:ss:mm"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="addClick()" v-if="isAdmin">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 主体 -->
    <div class="content">
      <el-card class="box-card table">
         <!-- 列表 -->
        <div>
          <div v-for="(item,index) in tableData" :key="item.id" :label="item.name" :vlaue="item.id">
            <div class="rowleft">
              <el-card class="box-card table">
                <div class="leftright">
                  <div>
                    <el-button
                      style="float: right;padding:0px;width:20px;height:20px;line-height:20px;text-align:center;border-radius:50%;"
                      type="danger"
                      icon="el-icon-close"
                      size="mini"
                      @click="delClick(item.id)"
                      v-if="isAdmin"
                    ></el-button>
           
                  </div>
                  <div class="leftintrol">
                              <div class="summarize">
                      <div class="title">结算日期：</div>
                      <div class="namesplit">
                       {{item.sendDate}}
                      </div>
                    </div>
                    <div class="summarize">
                      <div class="title">结算详情：</div>
                      <div class="namesplit">
                        <div
                          class="name"
                          v-for="(item,index) in item.content.split('\n')"
                          :label="item"
                          :value="item"
                          :key="index"
                        >{{item}}</div>
                      </div>
                    </div>
                    <div class="summarize" v-if="item.summary">
                      <div class="title">备注说明：</div>
                      <div class="namesplit" >
                        <div
                          class="name"
                          v-for="item in item.summary.split('\n')"
                          :label="item"
                          :value="item"
                          :key="item"
                        >{{item}}</div>
                      </div>
                    </div>
                   
                  </div>
                  <div class="clear"></div>
                </div>
              </el-card>
            </div>
            <div class="line" v-if="index%3==2||index==tableData.length-1"></div>
          </div>
          <div class="blank" v-if="tableData.length==0">暂无数据~~</div>
        </div>

        
        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑提成':'添加提成'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
      
        <el-form-item label="发放时间" prop="sendDate" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="form.sendDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结算详情" prop="content" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="textarea" v-model="form.content" :autosize="{ minRows: 10}" placeholder="请输入结算详情"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="summary" :rules="[{required:false,message:'不能为空'}]">
          <el-input type="textarea" v-model="form.summary" placeholder="请输入备注"></el-input>
        </el-form-item>


        <el-form-item class="dialog-footer">
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      query: {
        daterange: [],
      },
      form: {},
        currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      submiting: false,
      loading: false,
      typelist: [
        { id: "null", name: "全部" },
        { id: 1, name: "自己" },
      ],
      prolist: [],
      projectlist: [],
      info: {},
      isAdmin:user.isAdmin()
    };
  },
  methods: {
        handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    getUserInfo: function () {
      var _this = this;
      var info = user.getInfo();
      _this.info = info;
    },
    //   获取项目
    getProjectList: function () {
      var _this = this;
      var link = url.getProject("getlistall");
      $.get(link, {}, (data) => {
        _this.prolist = data;
      });
    },
    //   列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = this.query;
            params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getFin("getlist_achi");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total=data.total;
      });
    },
    // 查询
    selList: function () {
      this.getList();
    },
    // 添加
    addClick: function () {
      this.dialogVisible = true;
      var now = new Date();

      this.form = {
      };
    },


    // 删除
    delClick: function (id) {
      var _this = this;
      var link = url.getFin("delete_achi");
      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.loading = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getFin("save_achi");
      var info = this.form;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    // 登陆人
    this.getUserInfo();
    // //   项目
    // this.getProjectList();
    //列表
    this.getList();
  },
};
</script>

<style scoped>
  .namesplit div[value*='**']{
     padding-top:15px;
  }
</style>